var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "max-width": "100%",
    "max-height": "100%",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m548.39 151.05h-257.63c-28.887 0-52.566 23.68-52.566 52.566v34.57h-34.57c-28.887 0-52.566 23.68-52.566 52.566v258.1c0 28.887 23.68 52.566 52.566 52.566l257.62 0.003906c28.887 0 52.566-23.68 52.566-52.566v-34.57h34.57c28.887 0 52.566-23.68 52.566-52.566l0.003906-258.11c0-28.887-23.68-52.566-52.566-52.566zm-196.54 363.71c0 10.891-8.5234 19.418-19.418 19.418-5.2109 0-10.418-2.3672-13.734-5.6836-3.3164-3.3164-5.6836-8.5234-5.6836-13.734v-75.773h-75.773c-5.2109 0-10.418-2.3672-13.734-5.6836-3.3164-3.3164-5.6836-8.5234-5.6836-13.734 0-10.891 8.5234-19.418 19.418-19.418h75.773v-75.773c0-10.891 8.5234-19.418 19.418-19.418 10.891 0 19.418 8.5234 19.418 19.418v75.773h75.773c10.891 0 19.418 8.5234 19.418 19.418 0 10.891-8.5234 19.418-19.418 19.418h-75.773zm210.27-53.516c0 7.5781-6.1562 13.734-13.734 13.734h-34.57v-184.22c0-28.887-23.68-52.566-52.566-52.566h-184.7v-34.57c0-7.5781 6.1562-13.734 13.734-13.734h258.1c7.5781 0 13.734 6.1562 13.734 13.734z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.cae31ae32f8281b384d70aa74fa51b3d.svg";
export { ForwardRef as ReactComponent };